// extracted by mini-css-extract-plugin
module.exports = {"container":"canvas_container__crBJ1","selection":"canvas_selection__2baYq","navigation":"canvas_navigation__1Unyw"};